var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { class: "card " + _vm.pinStyle }, [
      _vm.data.module_type === "App\\Models\\Post"
        ? _c(
            "div",
            [
              _c("post", {
                attrs: {
                  data: _vm.data,
                  post: _vm.data.module,
                  questions_enabled: _vm.questions_enabled,
                  pin: _vm.pinned,
                  section: _vm.section,
                },
              }),
            ],
            1
          )
        : _vm.data.module_type === "App\\Models\\Video"
        ? _c(
            "div",
            [
              _c("newsfeed-video", {
                attrs: { data: _vm.data, video: _vm.data.module },
              }),
            ],
            1
          )
        : _vm.data.module_type === "App\\Models\\Event"
        ? _c(
            "div",
            [
              _c("event", {
                attrs: { data: _vm.data, event: _vm.data.module },
              }),
            ],
            1
          )
        : _vm.data.module_type === "App\\Models\\Product"
        ? _c(
            "div",
            [
              _c("newsfeed-product", {
                attrs: { data: _vm.data, product: _vm.data.module },
              }),
            ],
            1
          )
        : _vm.data.module_type === "App\\Models\\Resource"
        ? _c(
            "div",
            [
              _c("newsfeed-resource", {
                attrs: { data: _vm.data, resource: _vm.data.module },
              }),
            ],
            1
          )
        : _vm.data.module_type === "App\\Models\\Job"
        ? _c(
            "div",
            [_c("job", { attrs: { data: _vm.data, job: _vm.data.module } })],
            1
          )
        : _vm.data.module_type === "App\\Models\\Stack\\Question"
        ? _c(
            "div",
            [
              _c("question", {
                attrs: { data: _vm.data, question: _vm.data.module },
              }),
            ],
            1
          )
        : _vm.data.module_type === "App\\Models\\Zoom"
        ? _c(
            "div",
            [
              _c("newsfeed-zoom-meeting", {
                attrs: { data: _vm.data, zoom: _vm.data.module },
              }),
            ],
            1
          )
        : _vm.data.module_type === "App\\Models\\ZoomWebinar"
        ? _c(
            "div",
            [
              _c("newsfeed-zoom-webinar", {
                attrs: { data: _vm.data, webinar: _vm.data.module },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.data.group != null || _vm.data.supplier != null
        ? _c("div", { staticClass: "pl-1 pr-1 pt-05 pb-05" }, [
            _vm.data.group !== null && this.section !== "group"
              ? _c("div", [
                  _c(
                    "a",
                    { attrs: { href: "/member/group/" + _vm.data.group.slug } },
                    [
                      _c(
                        "div",
                        { staticClass: "card text-white mb-0 border-0" },
                        [
                          _c("img", {
                            staticClass: "card-img img-fluid",
                            staticStyle: { height: "3rem" },
                            attrs: {
                              src:
                                _vm.data.group.group_cover == null
                                  ? "/images/cover.jpg"
                                  : _vm.data.group.group_cover.url,
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "card-img-overlay overflow-hidden overlay-dark d-flex align-items-center pt-05 pb-05 pl-1 pr-05",
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass: "text-white mb-0",
                                  staticStyle: { "line-height": "1rem" },
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.__("globals.posted_in")) + " "
                                    ),
                                  ]),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.data.group.title)
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn-sm btn-outline-white ml-auto",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.__("globals.view_group")) + " "
                                  ),
                                  _c("i", {
                                    staticClass: "feather icon-chevron-right",
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.data.supplier !== null && this.section !== "supplier"
              ? _c("div", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "/member/supplier/" + _vm.data.supplier.slug,
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "card text-white mb-0 border-0" },
                        [
                          _c("img", {
                            staticClass: "card-img img-fluid",
                            staticStyle: { height: "3rem" },
                            attrs: {
                              src:
                                _vm.data.supplier.supplier_cover_image == null
                                  ? "/images/cover.jpg"
                                  : _vm.data.supplier.supplier_cover_image.url,
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "card-img-overlay overflow-hidden overlay-dark d-flex align-items-center pt-05 pb-05 pl-1 pr-05",
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass: "text-white mb-0",
                                  staticStyle: { "line-height": "1rem" },
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.__("globals.posted_in")) + " "
                                    ),
                                  ]),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.data.supplier.title)
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn-sm btn-outline-white ml-auto",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.__("globals.view_page")) + " "
                                  ),
                                  _c("i", {
                                    staticClass: "feather icon-chevron-right",
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      this.data.type === "question"
        ? _c("div", { staticClass: " border-top text-right p-05" }, [
            _c(
              "a",
              {
                staticClass: "ml-auto text-bold-700 font-small-3",
                attrs: { href: "/member/question/" + _vm.data.module.slug },
              },
              [
                _vm._v(_vm._s(_vm.__("question.view_this_question")) + " "),
                _c("i", { staticClass: "feather icon-chevron-right" }),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      this.data.type === "post" && _vm.section === "sidebar"
        ? _c("div", { staticClass: "border-top p-05 text-right" }, [
            _c(
              "a",
              {
                staticClass: "btn-sm btn-flat-light text-bold-700",
                staticStyle: { color: "inherit" },
                attrs: { href: "/member/post/" + _vm.data.module.id },
              },
              [
                _vm._v(_vm._s(_vm.__("globals.view_post")) + " "),
                _c("i", { staticClass: "feather icon-arrow-right" }),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      this.data.type !== "question" && _vm.section !== "sidebar"
        ? _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-between border-top pl-05 pr-05",
            },
            [
              _c(
                "div",
                { staticClass: "font-small-3 text-bold-700" },
                [
                  _c("likes", {
                    attrs: {
                      id:
                        this.data.module.slug !== undefined
                          ? this.data.module.slug
                          : this.data.type === "zoom" ||
                            this.data.type === "zoom-webinar"
                          ? this.data.module.zoom_id
                          : this.data.module.id,
                      "likes-count": this.data.likesCount,
                      "is-liked": this.data.isLiked,
                      "liked-by-users": this.data.userLikes,
                      type:
                        this.data.type === "resource"
                          ? this.data.module.type
                          : this.data.type,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "font-small-3 text-bold-700" }, [
                _c(
                  "a",
                  {
                    staticClass: "d-block p-05",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.commentsShow = !_vm.commentsShow
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-comment-o" }),
                    _vm._v(" "),
                    _vm.commentsCount === 1
                      ? _c("span", [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(_vm.commentsCount),
                            },
                          }),
                          _vm._v(" " + _vm._s(_vm.__("globals.comment"))),
                        ])
                      : _c("span", [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.commentsCount === 0
                                  ? " "
                                  : _vm.commentsCount
                              ),
                            },
                          }),
                          _vm._v(" " + _vm._s(_vm.__("globals.comments"))),
                        ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "font-small-3 text-bold-700" },
                [
                  _c("social-share", {
                    attrs: {
                      id: this.data.id,
                      social: this.data.module.socialShare,
                    },
                    on: { shareModal: _vm.triggerShareModal },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.commentsShow
      ? _c(
          "div",
          [
            _c("comments", {
              attrs: {
                newsfeed_uuid: this.data.uuid,
                id:
                  this.data.module.slug !== undefined
                    ? this.data.module.slug
                    : this.data.type === "zoom" ||
                      this.data.type === "zoom-webinar"
                    ? this.data.module.zoom_id
                    : this.data.module.id,
                type:
                  this.data.type === "resource"
                    ? this.data.module.type
                    : this.data.type,
              },
              on: { length: _vm.updateCommentsCount },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.share_newsfeed
      ? _c(
          "div",
          [
            _c("newsfeed-share-modal", {
              attrs: {
                original_newsfeed_id: this.data.id,
                data: this.data,
                type: this.data.type,
              },
              on: {
                closeModal: function ($event) {
                  _vm.share_newsfeed = false
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }